import React from "react";
import PropTypes from "prop-types";
import { GetIconByName } from "../../config/icon";
import "./styles.scss";
import { DatePicker, Space } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { setGetDate } from "./redux/date-picker-action";
import moment from "moment";

const format = "HH:mm";
/* props description goes here
 lable= { string - isRequired}
 iconName = { string - isRequired }
 mainLayerOutOption = { Ex: flex-row / flex-column }
*/

const Index = ({ data, onChange }) => {
  const dispatch = useDispatch();
  const handleChange = (date, dateString) => {
    if (date && dateString) {
      dispatch(
        setGetDate({
          date: moment(dateString).format(),
          title: data.title,
        })
      );
      console.log("handleChange", date, dateString);
    } else {
      dispatch(
        setGetDate({
          date: "",
          title: "",
        })
      );
    }
  };

  const dateFormat = "YYYY-MM-DD";

  let inputElement = null;

  inputElement = (
    <>
      <Space direction="vertical" style={{ width: "100%" }}>
        <DatePicker
          className="dpw__datePicker"
          placeholder={
            data?.placeholder || data?.elementConfig?.placeholder || ""
          }
          // defaultValue={moment()}
          format={dateFormat}
          onChange={handleChange}
        />
        {/* <DatePicker
          className="dpw__datePicker"
          placeholder={data.placeholder}
          defaultValue={moment()}
          format={dateFormat}
          onChange={handleChange}
        /> */}
      </Space>
    </>
  );
  return (
    <div
      className={`d-flex flex-column date-picker-warpper
        ${data.mainLayerStyles} `}
    >
      {data.label && (
        <div className={`txt-label`}>
          {data.label}
          {data.iconName && (
            <span className={"sbw__title-icon"}>
              {GetIconByName(data.iconName)}
            </span>
          )}
          {data.isRequired && <b>*</b>}
        </div>
      )}

      <>{inputElement}</>
      {data.bottomMessage && (
        <div className={"dpw__bottom-message"}>{data.bottomMessage}</div>
      )}
      {/*---- error goes here -----*/}
      {data && data.validation && data.validation.required && data.touched && (
        <>
          {/*---- filed is required -----*/}
          {data.validation.required && !data.value && (
            <div className="dpw__statusCode">You can't keep this as empty</div>
          )}

          {/*----  invalid data-----*/}
          {data.value && data.invalidReason && (
            <div className="dpw__statusCode">{data.invalidReason}</div>
          )}
        </>
      )}
    </div>
  );
};

Index.propTypes = {
  lable: PropTypes.string,
  size: PropTypes.string,
};

Index.defaultProps = {
  lable: "Unkown",
  iconName: "Unkown",
};

export default Index;
